/** `/login?reason=` value set when the session ended under the user and could not be refreshed. */
export const LOGIN_REASON_SESSION_EXPIRED = "session-expired";

export const SESSION_EXPIRED_LOGIN_URL = `/login?reason=${LOGIN_REASON_SESSION_EXPIRED}`;
